"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpansionStatus = exports.BoundOverrideOp = exports.RatingRowOrigin = exports.RatingsRelativeReferenceKind = exports.RatingsKind = void 0;
exports.kindDefaultLevel = kindDefaultLevel;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
var RatingsKind;
(function (RatingsKind) {
    RatingsKind["Amr"] = "amr";
    RatingsKind["Oc"] = "oc";
})(RatingsKind || (exports.RatingsKind = RatingsKind = {}));
function kindDefaultLevel(kind) {
    switch (kind) {
        case RatingsKind.Amr: {
            return sigma_engine_shared_1.BoundaryLevel.Error;
        }
        case RatingsKind.Oc: {
            return sigma_engine_shared_1.BoundaryLevel.Warning;
        }
    }
}
var RatingsRelativeReferenceKind;
(function (RatingsRelativeReferenceKind) {
    RatingsRelativeReferenceKind["Signal"] = "signal";
    RatingsRelativeReferenceKind["Mapping"] = "mapping";
})(RatingsRelativeReferenceKind || (exports.RatingsRelativeReferenceKind = RatingsRelativeReferenceKind = {}));
var RatingRowOrigin;
(function (RatingRowOrigin) {
    RatingRowOrigin["Entered"] = "entered";
    RatingRowOrigin["Reconstructed"] = "reconstructed";
})(RatingRowOrigin || (exports.RatingRowOrigin = RatingRowOrigin = {}));
var BoundOverrideOp;
(function (BoundOverrideOp) {
    BoundOverrideOp["Add"] = "add";
    BoundOverrideOp["Remove"] = "remove";
    BoundOverrideOp["Change"] = "change";
})(BoundOverrideOp || (exports.BoundOverrideOp = BoundOverrideOp = {}));
var ExpansionStatus;
(function (ExpansionStatus) {
    ExpansionStatus["Expanded"] = "expanded";
    ExpansionStatus["Unrecognized"] = "unrecognized";
})(ExpansionStatus || (exports.ExpansionStatus = ExpansionStatus = {}));
//# sourceMappingURL=rating-expansion.types.js.map